import { ITeamCustomData, Team } from "@common/ADAPT.Common.Model/organisation/team";

export class TeamExtensions {
    public constructor(private team: Team) {
    }

    public getCustomData() {
        if (!this.team.customData) {
            return {} as ITeamCustomData;
        }

        try {
            return JSON.parse(this.team.customData) as ITeamCustomData;
        } catch {
            return {} as ITeamCustomData;
        }
    }

    public updateCustomData(customData: ITeamCustomData) {
        this.team.customData = JSON.stringify(customData);
    }

    public getIcon() {
        const customData = this.getCustomData();
        return customData?.icon
            ?? this.team.teamTypeConfiguration?.icon
            ?? "fa-users";
    }

    public getIconColour() {
        const customData = this.getCustomData();
        return customData?.iconColour
            ?? this.team.teamTypeConfiguration?.iconColour
            ?? undefined;
    }

    public getBackgroundColour() {
        const customData = this.getCustomData();
        return customData?.backgroundColour
            ?? this.team.teamTypeConfiguration?.backgroundColour
            ?? undefined;
    }
}
